<div class="ewo-filter-bar" *ngIf="filterGroups.length > 0">
    <!-- Header row: title + count + sort + clear all -->
    <div class="filter-bar-header">
        <div class="filter-bar-title">
            <span class="material-icons-outlined">filter_list</span>
            <span>Filter</span>
            <span class="active-filter-badge" *ngIf="getActiveFilterCount() > 0">
                {{ getActiveFilterCount() }}
            </span>
        </div>
        <span class="filter-result-count">
            Showing <strong>{{ hasActiveFilters() ? visibleCount : totalCount }}</strong> of <strong>{{ totalCount }}</strong>
        </span>

        <!-- Sort dropdown -->
        <div class="sort-dropdown-wrapper">
            <button
                type="button"
                class="sort-toggle-btn"
                [class.active]="sortOrder !== 'none'"
                [attr.aria-label]="'Sort by date'"
                (click)="toggleSortDropdown($event)">
                <span class="material-icons-outlined">{{ getSortIcon() }}</span>
                {{ getSortLabel() }}
                <span class="material-icons-outlined sort-caret">arrow_drop_down</span>
            </button>
            <div class="sort-dropdown-menu" *ngIf="sortDropdownOpen">
                <button
                    type="button"
                    class="sort-option"
                    [class.selected]="sortOrder === 'newest'"
                    (click)="selectSort('newest')">
                    <span class="material-icons-outlined">arrow_downward</span>
                    Newest First
                </button>
                <button
                    type="button"
                    class="sort-option"
                    [class.selected]="sortOrder === 'oldest'"
                    (click)="selectSort('oldest')">
                    <span class="material-icons-outlined">arrow_upward</span>
                    Oldest First
                </button>
            </div>
        </div>

        <button
            type="button"
            class="clear-all-btn"
            *ngIf="hasAnyActiveState()"
            (click)="clearAll()">
            <span class="material-icons-outlined">close</span>
            Clear all
        </button>
    </div>

    <!-- Filter groups (one row per field) -->
    <div class="filter-groups">
        <div class="filter-group" *ngFor="let group of filterGroups">
            <span class="filter-group-label">{{ group.label }}</span>
            <div class="filter-chips-row">
                <button
                    type="button"
                    class="filter-chip"
                    *ngFor="let chip of group.chips"
                    [class.active]="activeFilters[group.field] === chip.value"
                    (click)="toggleChip(group.field, chip.value)"
                    [attr.aria-pressed]="activeFilters[group.field] === chip.value"
                    [attr.aria-label]="group.label + ': ' + chip.value + ' (' + chip.count + ')'">
                    {{ chip.value }}
                    <span class="chip-count">{{ chip.count }}</span>
                </button>
            </div>
        </div>
    </div>

    <!-- No match state -->
    <div class="filter-no-match" *ngIf="hasActiveFilters() && visibleCount === 0">
        <span class="material-icons-outlined">search_off</span>
        No cards match the selected filters.
        <button type="button" class="clear-all-inline" (click)="clearAll()">Clear filters</button>
    </div>
</div>
